// Aviso padrão: e-mail pode estar em spam/lixo/promoções
import React from 'react';

export const EmailInboxHint = React.memo(() => (
  <div
    style={{
      marginTop: 16,
      padding: '12px 14px',
      backgroundColor: '#FFFBEB',
      border: '1px solid #FCD34D',
      borderRadius: 8,
      fontSize: 13,
      color: '#92400E',
      lineHeight: 1.55,
    }}
  >
    <div style={{ fontWeight: 600, marginBottom: 6 }}>📬 Não encontrou na caixa de entrada?</div>
    <div style={{ marginBottom: 6 }}>Verifique também:</div>
    <ul style={{ margin: '0 0 8px 18px', padding: 0 }}>
      <li>Spam / Lixo eletrônico</li>
      <li>Promoções (Gmail)</li>
    </ul>
    <div style={{ fontSize: 12, color: '#B45309' }}>Pode levar alguns minutos para o e-mail chegar.</div>
  </div>
));
